import React = require("react");
import {WidgetResponse} from "../../DashboardContainer";
import {Loader} from "../../../components/Utils/loader/Loader";
import {FilterCountCard} from "./components/FilterCountCard";
import {VeBoxCard} from "../../../components/card/VeBoxCard";
import {Stylable} from "../../../components/common/PropsType";

export interface WidgetCountData {
    title: string;
    shortcutCode: string;
    total: number;
    count: number;
}

export interface CardConfig {
    color?: string;
    anticlockwise?: boolean;
}

interface WidgetProps extends Stylable {
    data: WidgetResponse | WidgetCountData[];
    title: string;
    stackManager: any
    showWidgetFunction: () => void;
    headerClassName?: string;
    cardClassName?: string;
    nextToTitle?: JSX.Element;
    cardsConfigs?: CardConfig[];
}


interface WidgetState {
    response: WidgetCountData[];
}

export class CountsWidget extends React.Component<WidgetProps, WidgetState, Stylable> {
    constructor(props: WidgetProps) {
        super(props);
        this.state = {
            response: null,
        };
        if (!Array.isArray(this.props.data)) {
            this.retrieveData();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (Array.isArray(this.props.data)
            && (!Array.isArray(this.state.response) || !this.areEquals(this.state.response, this.props.data))
        ) {
            this.setState({
                response: this.props.data
            })
        }
    }


    public render() {
        let cards
        if (this.state.response === null || (Array.isArray(this.state.response) && this.state.response.length === 0)) {
            cards = (<div className="list-widget">
                <Loader/>
            </div>);
        } else {
            cards = this.state.response.map(
                (element, index) => {
                    return <FilterCountCard
                        title={element.title}
                        value={element.count}
                        total={element.total}
                        defaultColor={this.props.cardsConfigs ? this.props.cardsConfigs[index].color : undefined}
                        anticlockwise={this.props.cardsConfigs ? this.props.cardsConfigs[index].anticlockwise : undefined}
                        reverseColors={
                            element.shortcutCode == "GOTO_EQUIPMENT_BELOW_TARGET"
                            || element.shortcutCode == "GOTO_EQUIPMENT_OUT_OF_STOCK"
                        }
                        noGreen={element.shortcutCode == "GOTO_EQUIPMENT_OUT_OF_STOCK"}
                        shortcutCode={element.shortcutCode}
                        stackManager={this.props.stackManager}
                        key={index}
                    />
                }
            );
        }

        return (
            <div className={(this.props.className ?? "")} style={this.props.style}>
                <VeBoxCard className={(this.props.cardClassName || "") + " home-dashboard-card list-widget counts-widget "}>
                    <VeBoxCard.Header
                        className={"list-widget__header space-between " + (this.props.headerClassName || "")}
                        title={this.props.title.toUpperCase()}
                        titleClassName={"lowercase capitalize"}
                        back={this.props.nextToTitle}
                        singleLineTitle={true}
                    />
                    <VeBoxCard.Body className="list-widget__content">
                        {cards}
                    </VeBoxCard.Body>
                </VeBoxCard>
            </div>
        );
    }

    private retrieveData(): void {
        if ("dataUrl" in this.props.data) {
            const dataUrl: string = this.props.data.dataUrl;
            Ajax.vbxAjax({
                url: dataUrl,
                type: "GET",
                cache: false,
                success: (response: WidgetCountData[]) => {
                    if (response.length == 0) {
                        return;
                    }
                    let allEmpty = true;
                    for (let i = 0; i < response.length && allEmpty; i++) {
                        if (response[i].total != 0) {
                            allEmpty = false;
                        }
                    }
                    if (allEmpty) {
                        return;
                    }
                    this.props.showWidgetFunction();
                    this.setState({
                        response,
                    });
                },
            });
        }
    }

    private areEquals(array1: WidgetCountData[], array2: WidgetCountData[]): boolean {
        if (array1.length === array2.length) {
            let equals = true
            array1.forEach((elem1) => {
                if (array2.find((elem2) => this.widgetCountDataEquals(elem1, elem2)) === undefined) {
                    equals = false;
                }
            })
            return equals
        }
        return false
    }

    private widgetCountDataEquals(elem1: WidgetCountData, elem2: WidgetCountData): boolean {
        return elem1.count === elem2.count && elem1.total === elem2.total && elem1.title === elem2.title && elem1.shortcutCode === elem2.shortcutCode;
    }
}